function SchedulePage() {
    return <div>This is the Schedule content</div>
  }

export default SchedulePage